import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class ResourcesPageService {
  tabsEnabled$: Observable<boolean>;

  private readonly tabsEnabledSource$ = new Subject<boolean>();

  constructor() {
    this.tabsEnabled$ = this.tabsEnabledSource$.asObservable();
  }

  setTabsState(active: boolean): void {
    this.tabsEnabledSource$.next(active);
  }
}
